<template src="./main.html"></template>



<script>
import Header from "./layout/Header.vue"
import Footer from "./layout/Footer.vue"
import Home from "./views/Home.vue"
//import Home from "./views/2019/Home.vue"

export default {
  components: {
    Header,
    Home,
    Footer
  },

};
</script>




